<template>
  <surround
    :surround-image="surroundImage"
    :title="title"
    :back-link="backLink"
  >
    <div class="playlist-content">
      <!-- <h1>{{ title }}</h1> -->
      <audio-playlist
        :playlist="playlist"
        @event="handlePlaylistEvent"
      />
    </div>
  </surround>
</template>

<script>
import AudioPlaylist from '../components/AudioPlaylist.vue'
import theplaylist from '../data/playlist.json'

export default {
  name: 'PlaylistPage',
  components: {
      AudioPlaylist
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    surroundImage: {
      type: String,
      default: ''
    },
    playlistKey: {
        type: String,
        default: ''
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false
    }
  },
  data() {
    return {
      itemsLoaded: false,
    }
  },
  computed: {
    staticPlaylist() {
        return theplaylist.map(i => {
            i.file = process.env.BASE_URL + i.file
            return i
        })
    },
    playlist() {
        const pl = this.playlistKey && this.itemsLoaded ? this.$store.getters.itemsDict.playlist[this.playlistKey] : false
        if (pl) {
          return pl.items
        }
        return []
    }
  },
  beforeMount() {
    this.$store.dispatch('refreshItems', 'playlist').then(() => {
      this.itemsLoaded = true;
    })
  },
  methods: {
    handlePlaylistEvent(event) {
      this.$gtm.trackEvent({
        category: 'Brazilian Playlist',
        action: 'Play',
        label: event.track.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.playlist-content {
  @include flex-vertical;
  @include flex-fill-vertical;
  padding: 2rem;
}
</style>
